import styled from "styled-components";

const Container = styled.p`
  color: red;
`;

export const S = {
  Container,
};
